import PathwayViewer from "./PathwayViewer"

export default PathwayViewer